import axios from 'axios'
import Vue from 'vue'

const API_URL = process.env.NODE_ENV !== 'development' ? process.env.VUE_APP_BACK_SERVER || 'https://api.vegetalsgv.com.br/' : process.env.VUE_APP_BASE_URL
const BASIC_AUTH = process.env.VUE_APP_BASIC_AUTH

const addAuthorizationToken = (data, headers) => {
  let currentUserJson = localStorage.currentUser
  if (currentUserJson && currentUserJson != 'null') {
    const token = JSON.parse(currentUserJson).token
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }

  if (data instanceof FormData) return data;

  return JSON.stringify(data)
}

const addBasicAuth = (data, headers) => {
  if (BASIC_AUTH && BASIC_AUTH.length) {
    headers.Authorization = `Basic ${BASIC_AUTH}`;
  }

  if (data instanceof FormData) return data

  return JSON.stringify(data)
}

const showErrorToast = function (e){
  if(e && e.response && e.response.data && typeof e.response.data === 'string' && e.response.data.length < 250){
    Vue.toasted.global.defaultError({msg: e.response.data})
  }else if(typeof e === 'string'){
    Vue.toasted.global.defaultError({msg: e })
  }
  else if(e.response.data && e.response.data && e.response.data.errors){
    if(e.response.data.meta && e.response.data.meta.skip_alert == 'login_page') return;
    if(!Array.isArray(e.response.data.errors)) return;
    e.response.data.errors.forEach(message => Vue.toasted.global.defaultError({msg: message}))
  } else {
    Vue.toasted.global.defaultError()
  }
}

const AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: addAuthorizationToken
})

const AxiosBasicAuthInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: addBasicAuth
})

AxiosInstance.interceptors.response.use(function (response) {
  if (response.headers['x-runtime'] && response.headers['x-runtime'] > 1) {
    const time = (response.headers['x-runtime'] * 1000).toFixed(2)
    console.warn(`[Axios] request took ${time}ms to complete`)

    if (process.env.NODE_ENV === 'development') {
      Vue.toasted.global.defaultDebug({msg: `[Axios] request to ${response.config.url} took ${time}ms to complete!<br>Optimization needed!`})
    }
  }

  return response;
}, function (error) {
  console.warn("[Axios] request error: ", error)

  if(error.response.status === 401 && error.response.config && !error.response.config.__isRetryRequest){
    if(!error.request.responseURL.match('\/login|recuperacaoConta\/?$')){
      Vue.extend({}).prototype.$authenticateUser()
    } else {
      Vue.extend({}).prototype.$unauthenticateUser()
    }
  }
  return Promise.reject(error);
});

export { AxiosInstance as default, API_URL as apiUrl, AxiosBasicAuthInstance as basicAuthAxios };

